export const flatResponse = (data) => {
	const transformed = {
		bids_enabled: data.bids.enabled,
		bids_email_frequency: data.bids.bids_email_frequency,
		bids_sms_frequency: data.bids.bids_sms_frequency,
		outbid_push_frequency: data.bids.outbid_push_frequency,

		matches_enabled: data.matches.enabled,
		matches_email_frequency: data.matches.matches_email_frequency,
		matches_sms_frequency: data.matches.matches_sms_frequency,

		vehicles_sold_enabled: data.vehicles_sold.enabled,
		vehicle_sold_sms: data.vehicles_sold.vehicle_sold_sms,
		vehicle_sold_push: data.vehicles_sold.vehicle_sold_push,
		vehicle_sold_email: data.vehicles_sold.vehicle_sold_email,

		strong_bids_enabled: data.strong_bids.enabled,
		strong_bid_sms: data.strong_bids.strong_bid_sms,
		strong_bid_email: data.strong_bids.strong_bid_email,
		strong_bid_push: data.strong_bids.strong_bid_push,
	};
	return transformed;
};
